import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, goBack } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import sha256 from 'sha256'

// ------------------------------------
// Constants
// ------------------------------------
export const AUTO_LOGIN = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
  },
  'AUTO_LOGIN'
)

// ------------------------------------
// Actions
// ------------------------------------
export function login() {
  return (dispatch) => {
    if (process.env.NODE_ENV === 'development') {
      // 测试用户：971140252158413237 132580||147222
      return dispatch(
        init({
          codeVerifier: 'test',
          verifyToken: '17482da5423a476f8b0d55c9c7c25e22'
        })
      )
    }
    return dispatch(getVerifyToken())
  }
}

export function getVerifyToken() {
  return (dispatch) => {
    function onBridgeReady() {
      // Bridge方法注册成功
      console.log('ToPayJSBridge:start')
      try {
        // window.ToPayJSBridge.init 方法二次调用的时候会报错
        window.ToPayJSBridge.init(function(message, responseCallback) {})
      } catch (error) {
      }
      const random = Math.random().toString(16).slice(-8)
      window.ToPayJSBridge.invoke(
        'getVerifyToken',
        {
          codeChallenge: sha256(random),
          appDomain: window.location.hostname,
        },
        function(data) {
          console.log('data', data)
          if (data) {
            const res = JSON.parse(data)
            console.log('ToPayJSBridge:res', res)
            if (res && res.verifyToken) {
              dispatch(
                init(
                  Object.assign({}, res, {
                    codeVerifier: random,
                  })
                )
              )
            }
          }
        }
      )
    }
    console.log(typeof ToPayJSBridge)
    if (typeof ToPayJSBridge === 'undefined') {
      document.addEventListener('ToPayJSBridgeReady', onBridgeReady, false) // ToPayJSBridgeReady
    } else {
      onBridgeReady()
    }
  }
}

export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/h5app/auth/v2/verify',
        body: {
          verifyToken: data.verifyToken,
          codeVerifier: data.codeVerifier,
        },
        method: 'POST',
        requestAction: AUTO_LOGIN.INIT_REQUEST,
        successAction: AUTO_LOGIN.INIT_SUCCESS,
        success: function(result) {
          // 获取userId,传入countly
          localStorage.setItem('user_id', result.userId)
          dispatch(goBack())
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [AUTO_LOGIN.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [AUTO_LOGIN.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'routesAutoLogin',
    reducerMap: {
      routesAutoLoginState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
